import {
  ACCESS_NATIVE_APP_ID,
  PROTECT_NATIVE_APP_ID,
  MAILROOM_NATIVE_APP_ID,
  VIDEO_NATIVE_APP_ID,
} from '../../partnerCenterApp/constants/native-apps';

type TokenScopeOrg = Utils.DeepNonUndefined<
  Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >['org']
>;
type NativeAppIds =
  | typeof ACCESS_NATIVE_APP_ID
  | typeof PROTECT_NATIVE_APP_ID
  | typeof MAILROOM_NATIVE_APP_ID
  | typeof VIDEO_NATIVE_APP_ID;

export const findNativeApp = (
  orgNativeApps:
    | Api.Response['listOrgNativeApps']
    | TokenScopeOrg['orgNativeApps'] = [],
  nativeAppId: NativeAppIds,
) =>
  orgNativeApps.find(({ nativeApp }) => {
    return nativeApp.id === nativeAppId;
  });
